module.exports = "./img/7a5bf16c63c4fab8e42cc4f60933c0c7.png";